import { render, staticRenderFns } from "./batteryDetail.vue?vue&type=template&id=b5fe2f98&scoped=true&"
import script from "./batteryDetail.vue?vue&type=script&lang=js&"
export * from "./batteryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fe2f98",
  null
  
)

export default component.exports